var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{attrs:{"id":_vm.containerId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }